import React from "react";
import { MapPin } from "lucide-react";
import { journey } from "../mock";
import Reveal from "./Reveal";
import { useReveal } from "../hooks/useReveal";

const Journey = () => {
  const [lineRef, lineIn] = useReveal({ threshold: 0.05 });
  return (
    <section id="journey" className="bg-navy text-white relative overflow-hidden">
      <div className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full" style={{ background: "radial-gradient(circle, rgba(191,157,87,0.10), transparent 70%)" }} />
      <div className="max-w-5xl mx-auto px-4 py-20 relative">
        <Reveal className="text-center mb-16">
          <span className="text-xs font-bold tracking-[0.3em] uppercase text-gold">A Global Career</span>
          <h2 className="font-head text-3xl sm:text-4xl uppercase tracking-wide mt-2">The Journey</h2>
          <div className="w-16 h-0.5 bg-gold mx-auto mt-4" />
        </Reveal>

        <div ref={lineRef} className="relative">
          <div className="absolute left-[27px] top-3 bottom-3 w-0.5 bg-white/15">
            <div className={`tl-line${lineIn ? " in-view" : ""} w-full h-full bg-gold`} />
          </div>
          <div className="space-y-8">
            {journey.map((j, i) => (
              <Reveal key={i} delay={1} className="relative flex items-center gap-6">
                <div className="relative z-10 w-14 h-14 rounded-full bg-navy-2 border-2 border-gold flex items-center justify-center text-2xl shadow-lg shrink-0">
                  <span aria-hidden="true">{j.flag}</span>
                </div>
                <div className="flex-1 bg-white/5 backdrop-blur rounded-xl border border-white/10 px-6 py-4 flex flex-wrap items-center gap-x-4 gap-y-1">
                  <div className="flex items-center gap-2 font-head text-xl uppercase tracking-wide text-gold">
                    <MapPin className="w-4 h-4" /> {j.place}
                  </div>
                  <span className="text-white/40">|</span>
                  <span className="text-white/75 text-sm">{j.roles.join("  \u2022  ")}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Journey;
